<template>
  <main id="main">
    <slot v-if="ready"/>
    <Transition name="fade" mode="out-in">
      <Loader v-if="!ready"/>
    </Transition>
  </main>
</template>

<script>
import {Loader} from '@/components/small'

export default {
  name: 'PageWithLoading',
  components: {Loader},
  props: {
    ready: {
      type: Boolean,
      required: true
    }
  }
}
</script>